module.exports = __webpack_public_path__ + "static/media/1004863.7d0c29e6.png";